import styled from 'styled-components';
import {Space} from 'antd';
import {bordersStyles, typographyStyles} from '../../../../utils/styles';

const StyledHeaderDetails = styled.div`
  ${bordersStyles.light};
  align-items: self-start;
  background: ${props => props.theme.colors.neutral_1};
  display: flex;
  justify-content: space-between;
  padding: 24px;
  background: linear-gradient(0deg, ${props => props.theme.colors.neutral_1}, ${props => props.theme.colors.neutral_1}),
              linear-gradient(0deg, ${props => props.theme.colors.neutral_3}, ${props => props.theme.colors.neutral_3});

  .ant-space {
    p {
      ${typographyStyles.footnote.description};
      color: ${props => props.theme.colors.neutral_6};
    }
  }
`;

const StyledHeaderDetailsInfoSpace = styled(Space)`
  min-height: 52px;
`;

const StyledHeaderDetailsInfo = styled.div`
  ${typographyStyles.footnote.description};
  color: ${props => props.theme.colors.neutral_6};

`;

export {
  StyledHeaderDetails,
  StyledHeaderDetailsInfo,
  StyledHeaderDetailsInfoSpace
}
